import React from 'react';
import { Instagram } from 'lucide-react';
export const InstagramRibbon = () => {
  return <a href="#" className="block w-full bg-be-pink hover:bg-be-pink-light transition-colors text-white py-4 flex justify-center items-center gap-3 px-4 text-center" data-id="element-123">
      <Instagram size={20} data-id="element-124" />
      <span className="text-sm sm:text-base font-bold tracking-[0.2em] uppercase" data-id="element-125">
        FOLLOW US @BECLINICAL_
      </span>
    </a>;
};